import montageBg from 'public/static/images/about_us/people.jpg';
import { flexBoxFullWidthCSS } from 'components/styles';

const Montage = () => (
  <div className={`outer-container ${flexBoxFullWidthCSS.className}`}>
    <div className="background" />
    <style jsx>{`
      .outer-container {
        position: relative;
        height: 375px;
      }

      .background {
        background-image: url(${montageBg});
        background-size: 1500px 375px;
        background-position: center top;
        height: 100%;
      }
    `}</style>
    {flexBoxFullWidthCSS.styles}
  </div>
);

export default Montage;
